import styled from 'styled-components';

const StyledNumberColImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  align-self: stretch;
  overflow: hidden;
  .image--column{
    width: 100%;
    height: 100%;
    background-position: 50%;
    background-size: cover;
  }
  
`;

export {
  StyledNumberColImage,
};

